module.exports = "fragment GroupFragment on Group {\n  id\n  name\n}\n"